<template>
  <div>
    <!-- HERO -->
    <HeroSustainability
      class="relative z-10"
      :data="page"
      @resize="onResize($event)"
    >
      <template #sidebar>
        <SustainabilityFactsSidebar class="xl:hidden" :page="page" />
      </template>
    </HeroSustainability>

    <!-- CONTENT SIDEBAR -->
    <div ref="elContentSidebar" class="pointer-events-none">
      <div class="relative grid-cols-4 xl:grid xl:pr-container-desktop-wide">
        <div
          ref="elContentSidebarContent"
          class="col-span-3 px-container-wide sm:px-container-desktop-wide xl:pr-6"
        >
          <div class="pointer-events-auto relative my-16">
            <ComponentsLoaderSustainability :components="page.content" />
          </div>
        </div>
        <!-- DESKTOP -->
        <AnimatedContainer>
          <SustainabilityFactsSidebar
            class="fade-in pointer-events-auto z-20 col-span-1 hidden xl:block"
            :page="page"
          />
        </AnimatedContainer>
      </div>
    </div>

    <!-- CONTENT -->
    <div>
      <Container indent="wide">
        <div class="flex flex-wrap gap-x-6 gap-y-4 pb-16 pt-3 sm:pb-24 sm:pt-8">
          <!-- Pdf download -->
          <AppButtonFileDownload
            v-if="page.file_pdf"
            is-blue
            is-small-on-mobile
            :file="page.file_pdf"
          >
            <template #default>
              {{ $t('download_pdf') }}
            </template>
          </AppButtonFileDownload>

          <!-- News Article Link -->
          <AppButton
            v-if="page.news_article"
            is-secondary
            is-small-on-mobile
            :to="page.news_article.url"
          >
            {{ $t('read_full_article') }}
          </AppButton>
        </div>

        <!-- <SocialShareIcons :alternates="page.alternates" class="mb-16" /> -->
      </Container>
      <ComponentsLoader
        v-editor-target="'sustainability_fact_site_end_replicator'"
        :components="page.sustainability_fact_site_end_replicator"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  page: { type: Object, required: true },
})

provide('isSustainabilityArticle', true)

const pageRef = ref(props.page)
watch(
  () => props.page,
  (newValue) => {
    pageRef.value = newValue
  }
)
provide('page', pageRef)

const elContentSidebar = ref(null)
const elContentSidebarContent = ref(null)

const isSidebarReady = ref(false)

// FUNCTIONS
function onResize(height) {
  isSidebarReady.value = true
  if (!elContentSidebar.value) {
    return
  }

  elContentSidebarContent.value.style.paddingTop = height + 'px'
  elContentSidebar.value.style.marginTop = -height + 'px'
}
</script>
